// ===== Bea Joyas — capa de datos REAL (Shopify) para la app del prototipo =====
// Reemplaza el data.jsx hardcodeado: lee window.BEA_DATA (inyectado por Liquid con
// los productos reales) y expone las mismas variables/helpers en window que usan
// ui/cards/shop/screens/etc. Imágenes = URLs completas de Shopify. Sin descuentos
// en individuales (price === sale salvo combos, donde price = compare_at).
const fmt = (n) => "$" + Number(n || 0).toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const RING_SIZES = [
  { label: "5", mm: "15 mm" }, { label: "6", mm: "16 mm" }, { label: "7", mm: "17 mm" },
  { label: "8", mm: "18 mm" }, { label: "9", mm: "19 mm" },
];

const _D = (typeof window !== "undefined" && window.BEA_DATA) || { products: [], categories: [] };
// Envío gratis SOLO en piezas de $70.000 o más (umbral real). El resto sin cartel.
const FREE_SHIP_MIN = 70000;
const PRODUCTS = (_D.products || []).map(function (p) {
  return Object.assign({}, p, { freeShip: (Number(p.sale) || 0) >= FREE_SHIP_MIN });
});
const CATEGORIES = _D.categories && _D.categories.length ? _D.categories : [
  { slug: "anillos", name: "Anillos", blurb: "Para cada gesto" },
  { slug: "aros", name: "Aros", blurb: "Luz en la oreja" },
  { slug: "collares", name: "Collares", blurb: "Cerca del corazón" },
  { slug: "pulseras", name: "Pulseras", blurb: "En cada movimiento" },
];
const TEMPLATE = PRODUCTS.length === 0;

// imágenes = URLs de Shopify servidas con ?width=1280. Reescribimos el width al tamaño
// pedido ("640-0" -> 640, "1024-1024" -> 1024) para no bajar 1280px en cada miniatura:
// eso es lo que hacía que las cards "cargaran en gris". El CDN de Shopify sirve el tamaño exacto.
const _reW = (u, size) => {
  const w = parseInt(String(size || ""), 10);
  return (u && w) ? u.replace(/([?&])width=\d+/, "$1width=" + w) : u;
};
const photoURL = (u, size) => _reW(u, size);
const imgsOf = (p, size) => (p && p.imgs ? (size ? p.imgs.map((u) => _reW(u, size)) : p.imgs) : []);
const hasImg = (p) => !!(p && p.imgs && p.imgs.length);

const byCat = (slug) => PRODUCTS.filter((p) => p.cat === slug);
const featured = () => {
  const list = PRODUCTS.filter((p) => p.tag === "top" || p.stock);
  return [...list].sort((a, b) => (hasImg(b) ? 1 : 0) - (hasImg(a) ? 1 : 0)).slice(0, 8);
};
const newest = () => PRODUCTS.filter((p) => p.tag === "nuevo");
const findP = (id) => PRODUCTS.find((p) => String(p.id) === String(id));
const catName = (slug) => (CATEGORIES.find((c) => c.slug === slug) || {}).name || "Productos";
const catImg = (slug) => { const p = byCat(slug).find(hasImg); return p ? p.imgs[0] : null; };
const allRealImgs = () => PRODUCTS.filter(hasImg).flatMap((p) => p.imgs);

Object.assign(window, {
  fmt, PRODUCTS, CATEGORIES, RING_SIZES, TEMPLATE,
  byCat, featured, newest, findP, catName,
  photoURL, imgsOf, hasImg, catImg, allRealImgs,
});

// Checkout real de Shopify: el carrito de la app YA es el carrito real (Ajax Cart API),
// así que solo hace falta ir al checkout nativo.
window.shopifyCheckout = function () {
  window.location.href = "/checkout";
};
